import { combineReducers } from "@reduxjs/toolkit";
import loginSlice from "./slices/loginSlice";
import usersSlice from "./slices/User/usersSlice";
import formSlice from "./slices/formSlice";
import userRoleSlice from "./slices/User/userRoleSlice";
import userDesignationSlice from "./slices/User/userDesignationSlice";
import organizationSlice from "./slices/Organization/OrganizationSlice";
import UserRoleRouteSlice from "./slices/UserRoute/UserRoleRouteSlice";
import checklistSlice from "./slices/Checklist/checklistSlice";
import caseSlice from "./slices/Case/caseSlice";
import allotmentDocumentSlice from "./slices/AllotmentDocuments/allotmentDocumentSlice";
import templateGroupingSlice from "./slices/TemplateGrouping/TemplateGroupingSlice";
import ChecklistDocumentSlice from "./slices/ChecklistDocuments/ChecklistDocumentSlice";
import empanelmentSlice from "./slices/Empanelment/empanelmentSlice";
import organizationRegionSlice from "./slices/OrganizationRegion/OrganizationRegionSlice";
import dashboardSlice from "./slices/Dashboard/DashboardSlices";
import boardsAndPanelSlice from "./slices/boardsAndPanel/boardsAndPanelSlice";
import CaseTaskSlice from "../redux/slices/Task/CaseTaskSlices";
import caseDocumentsSlice from "../redux/slices/CaseDocuments/caseDocumentsSlice";
import tenantSlice from './slices/Tenant/TenantSlice'
import noticeTemplateGeneraterSlice from "./slices/NoticeTemplates/noticeTemplatesSlice";
import ticketsSlice from "../redux/slices/Tickets/ticketsSlices";
import supportReducer from "./slices/support/supportSlices";
import tenantslice from './slices/tenants/tenantSlices'
import cd_caseDocsSlice from "./slices/cd_caseDocs/cd_caseDocsSlices";
import vehicleSlice from "./slices/Case/vehicleSlice";
import propertySlice from "./slices/Case/propertySlice";
import bankAccountSlice from "./slices/Case/bankAccountSlice";
import salaryAttachmentSlice from "./slices/Case/SalaryAttachmentSlice";
import otherDetailsSlice from "./slices/Case/otherDetailsSlice";
import billingsSlice from "./slices/Case/billingsSlice";
import claimantDetailsSlice from "./slices/ClaimantDetails/claimantDetailsSlice";
import respondentDetailsSlice from "./slices/RespondentDetails/respondentDetailsSlice";
import claimantCounselSlice from "./slices/ClaimantCounsel/claimantCounselSlices";
import respondentCounselSlice from "./slices/RespondentCounsel/respondentCounselSlices";
import claimantAdministratorSlice from "./slices/ClaimantAdministrator/claimantAdministratorSlices";
import respondentAdministratorSlice from "./slices/RespondentAdministrator/respondentAdministratorSlices";
import arbitratorDetailsSlice from "./slices/ArbitratorDetails/arbitratorDetailsSlices";
import caseTagsSlice from "./slices/CaseTags/caseTagsSlices";
import sec17InterimOrdersSlice from "./slices/Sec17InterimOrders/sec17InterimOrdersSlices";
import sec17OrderRequestSlice from "./slices/Sec17OrderRequests/sec17OrderRequestsSlices";
import sec9InterimOrdersSlice from "./slices/Sec9InterimOrders/sec9InterimOrdersSlices";
import interimAwardsSlice from "./slices/InterimAwards/interimAwardsSlices";
import finalAwardsSlice from "./slices/FinalAwards/finalAwardsSlices";
import checklistVerificationSlice from "./slices/CaseChecklistTab/caseChecklistTabSlices";
import arbitratorAllocationSlice from "./slices/ArbitratorAllocation/arbitratorAllocationSlice";
import communicationSlice from "./slices/Communication/communicationSlices";
import commAuditTrailsSlice from "./slices/CommAuditTrails/commAuditTrailsSlices";
import alertsSlice from "./slices/Alerts/AlertsSlice";
import arbitrationProceedingsSlice from "./slices/ArbitrationProceedings/arbitrationProceedingsSlice";
import caseRoleAccessSlice from "./slices/CaseRoleAccess/caseRoleAccessSlice";
import caseMeetingSlice from "./slices/CaseMeeting/caseMeetingSlice";

export const rootReducer = combineReducers({
  alerts: alertsSlice,
  tenant: tenantSlice,
  empanelment: empanelmentSlice,
  login: loginSlice,
  users: usersSlice,
  formData: formSlice,
  userRoles: userRoleSlice,
  userDesignation: userDesignationSlice,
  organization: organizationSlice,
  organizationRegion: organizationRegionSlice,
  userRoleRouters: UserRoleRouteSlice,
  checklist: checklistSlice,
  ChecklistDocument: ChecklistDocumentSlice,
  case: caseSlice,
  templateGroupting: templateGroupingSlice,
  allotmentDocument: allotmentDocumentSlice,
  BoardsAndPanel: boardsAndPanelSlice,
  noticeTemplateGenerater: noticeTemplateGeneraterSlice,
  dashboard: dashboardSlice,
  caseTask: CaseTaskSlice,
  caseDocuments: caseDocumentsSlice,
  tickets: ticketsSlice,
  support: supportReducer,
  tenants: tenantslice,
  cd_caseDocs: cd_caseDocsSlice,
  bankAccount: bankAccountSlice,
  salaryAttachment: salaryAttachmentSlice,
  otherDetails: otherDetailsSlice,
  billings: billingsSlice,
  claimantDetails: claimantDetailsSlice,
  arbitrationProceedings: arbitrationProceedingsSlice,
  respondentDetails: respondentDetailsSlice,
  claimantCounsel: claimantCounselSlice,
  respondentCounsel: respondentCounselSlice,
  claimantAdministrator: claimantAdministratorSlice,
  respondentAdministrator: respondentAdministratorSlice,
  arbitratorDetails: arbitratorDetailsSlice,
  vehicle: vehicleSlice,
  property: propertySlice,
  caseTags: caseTagsSlice,
  sec17InterimOrders: sec17InterimOrdersSlice,
  sec17OrderRequests: sec17OrderRequestSlice,
  sec9InterimOrders: sec9InterimOrdersSlice,
  interimAwards: interimAwardsSlice,
  finalAwards: finalAwardsSlice,
  checklistVerification: checklistVerificationSlice,
  arbitratorAllocation: arbitratorAllocationSlice,
  communication: communicationSlice,
  commAuditTrails: commAuditTrailsSlice,
  caseRoleAccess: caseRoleAccessSlice,
  caseMeeting: caseMeetingSlice,
});
